import React, { useState } from "react";
import Modal from "../Modal";
import Button from "../Button";
import ModalErrorMessage from "../ModalErrorMessage";
import LoadingSpinner from "../Spinner";
import { CreateAccessTokenModalProps } from "./types";
import { ModalTitle, InputRow, Input, ActionsRow, ModalWrapper } from "./styles";

const CreateAccessTokenModal: React.FC<CreateAccessTokenModalProps> = ({
  open,
  onCancel,
  onCreate,
}) => {
  const [tokenName, setTokenName] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleCreate = async () => {
    if (!tokenName.trim()) {
      setError("Please enter a token name.");
      return;
    }
    setError(null);
    setLoading(true);
    try {
      setLoading(false);
      onCreate?.(tokenName);
      setTokenName("");
    } catch (e) {
      setLoading(false);
      setError("Failed to create access token.");
    }
  };

  if (!open) return null;

  return (
    <Modal onClick={onCancel}>
      <ModalWrapper>
        <ModalTitle>Create Access Token</ModalTitle>
        {error && <ModalErrorMessage message={error} inline />}
        {loading ? (
          <div style={{ width: "100%", textAlign: "center", marginBottom: "70px" }}>
            <div style={{ marginBottom: 16, fontSize: 18, fontWeight: 500 }}>Creating token...</div>
            <LoadingSpinner />
          </div>
        ) : (
          <>
            <div style={{ fontSize: 14, marginBottom: 8 }}>
              Enter a name for your access token:
            </div>
            <InputRow>
              <Input
                type="text"
                placeholder="Token name"
                value={tokenName}
                onChange={e => setTokenName(e.target.value)}
              />
            </InputRow>
            <ActionsRow>
              <Button 
                text="Cancel" 
                handleClick={onCancel} 
                $height="50px"
                $semilarge
              />
              <Button 
                text="Create" 
                handleClick={handleCreate} 
                $height="50px"
                $secondary
              />
            </ActionsRow>
          </>
        )}
      </ModalWrapper>
    </Modal>
  );
};

export default CreateAccessTokenModal;
